var myDiv = $(".limited");
myDiv.text(myDiv.text().substring(0, 109) + "....");
